import { render, staticRenderFns } from "./phoneCustomer.vue?vue&type=template&id=4cf51dd2&scoped=true"
import script from "./phoneCustomer.vue?vue&type=script&lang=js"
export * from "./phoneCustomer.vue?vue&type=script&lang=js"
import style0 from "./phoneCustomer.vue?vue&type=style&index=0&id=4cf51dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf51dd2",
  null
  
)

export default component.exports